import moment from "moment"

function secondsToString(seconds: number) {
  return moment.utc(seconds * 1000).format("HH:mm:ss")
}

export default secondsToString
